module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('header', [_h('nav', {
    staticClass: "container header"
  }, [_vm._m(0), " ", _h('div', {
    staticClass: "nav-person"
  }, [(!_vm.isLogin) ? _h('div', {
    staticClass: "nav-login"
  }, [_h('button', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#",
      "role": "button"
    }
  }, [_h('router-link', {
    attrs: {
      "to": "/register"
    }
  }, ["注册"])]), " ", _h('button', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#",
      "role": "button"
    }
  }, [_h('router-link', {
    attrs: {
      "to": "/login"
    }
  }, ["登录"])])]) : _h('div', {
    staticClass: "nav-login"
  }, [_h('div', {
    staticClass: "user-name"
  }, [_h('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_vm._s(_vm.cname)])]), " ", _h('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#",
      "role": "button"
    },
    on: {
      "click": _vm.signout
    }
  }, ["退出"])]), " "]), " ", _h('ul', {
    staticClass: "nav-menu"
  }, [_h('li', [_h('router-link', {
    attrs: {
      "to": "/todolist"
    }
  }, ["TODO"])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('h1', {
    staticClass: "logo"
  }, [_h('p', {
    staticClass: "logo_txt"
  }, ["TODOList"])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-61fe4271!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 43
// module chunks = 1